import { defineMessages } from 'react-intl';

export const mediaMessages = defineMessages({
	download: {
		id: 'message.media.download',
		defaultMessage: 'Download',
		description:
			'Download message displayed in message when the chat receives a media message',
	},
});
